import { cva, type VariantProps } from 'class-variance-authority';
import { forwardRef } from 'react';
import { cn } from '../../lib/utils';

export const buttonVariants = cva(
  'btn-press inline-flex items-center justify-center gap-2 cursor-pointer border font-sans disabled:opacity-50 disabled:cursor-not-allowed',
  {
    variants: {
      variant: {
        accent: 'bg-accent text-bg border-accent hover:bg-ink hover:border-ink',
        secondary:
          'bg-transparent text-ink border-stroke hover:bg-accent hover:text-bg hover:border-accent',
        ghost: 'bg-transparent text-muted border-transparent hover:text-ink',
      },
      size: {
        sm: 'px-3 py-2 text-[12px] font-semibold tracking-[-0.01em]',
        md: 'px-5 py-3 text-[13px] font-semibold tracking-[-0.01em]',
        lg: 'px-11 py-5 text-[15px] font-extrabold tracking-[-0.01em]',
      },
    },
    defaultVariants: { variant: 'secondary', size: 'md' },
  },
);

export interface ButtonProps
  extends React.ButtonHTMLAttributes<HTMLButtonElement>,
    VariantProps<typeof buttonVariants> {}

export const Button = forwardRef<HTMLButtonElement, ButtonProps>(
  ({ className, variant, size, ...props }, ref) => (
    <button
      ref={ref}
      type="button"
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  ),
);
Button.displayName = 'Button';
